module.exports = __webpack_public_path__ + "static/media/sketch-street-bob.1fc35ff5.png";